import api from './api';

export const login = async (username: string, password: string) => {
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    const response = await api.post('/token', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });

    // console.log(222)
    // console.log(response.data)
    localStorage.setItem('access_token', response.data.access_token);
    localStorage.setItem('refresh_token', response.data.refresh_token);
    localStorage.setItem('user_id', response.data.user_id);
};

export const register = async (email: string, password: string) => {
    await api.post('/users/', {email, password});
};

export const forgotPassword = async (email: string) => {
    await api.post('/forgot-password', {email});
};

export const isAuthenticated = () => {
    return !!localStorage.getItem('access_token');
};

export const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_id');
};